<template>
    <a class="btn std center white graybtn relative" v-bind:class="{inactive: !validInput}" v-on:click="submit()" >
      <span class="relative z4">{{name}}</span>
    </a>
</template>

<script>


import { EventBus } from "@/event-bus.js";

export default {
     name: 'SubmitButton',
    props: {
      name: String,
      event_name: String,
      button_style: Boolean,
      validInput: Boolean,
    },
    data() {
      return {
        debug: false,
        details: false,
        style_class: '',
      }
    },
    created() {
      if(this.style != "") {
        this.style_class = this.style;
      }
     }, 

     methods: {
      submit: function() {
          EventBus.$emit(this.event_name);
      },
      log: function (obj) {
        if(this.debug) {
          console.log(obj)
        }
      }
    }
}
</script>

<style scoped>
  .graybtn{
    background-color: #0176CD;
    opacity: 1
  }
  .graybtn::after{
    content: '';
    display: block;
    transition: 2s ease;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: #000;
    opacity: .3;
  }
  .inactive{
    pointer-events: none;
    background-color: #a3a3a3;
  }
</style>